import { render, staticRenderFns } from "./IconStopSolid.vue?vue&type=template&id=00ff2fb6"
import script from "./IconStopSolid.vue?vue&type=script&lang=js"
export * from "./IconStopSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports